import { Injectable } from '@angular/core';
import { IMockConfig } from './mock.interface';


@Injectable({
  providedIn: 'root'
})
export abstract class MockConfig implements IMockConfig {

  abstract readonly isDevMode: boolean;

  constructor() {
   
  }
}
